import { ModernLoggedOutHomepage } from '@fiverr-private/header/';

export default ModernLoggedOutHomepage;
